import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import * as React from "react";
import styled from "styled-components";
export var MakerSignUpMobileWrapper = function(param) {
    var children = param.children;
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(MobileWrapper, {
        children: [
            /*#__PURE__*/ _jsx(ImageWrapper, {
                $isSSR: isSSR,
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    linkTo: home(),
                    children: /*#__PURE__*/ _jsx(FaireLogo, {
                        size: 100
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SummarySection, {
                children: children
            })
        ]
    });
};
var MobileWrapper = styled(Column).withConfig({
    componentId: "sc-6b0a6fde-0"
})([
    "max-height:100vh;"
]);
var ImageWrapper = styled.div.withConfig({
    componentId: "sc-6b0a6fde-1"
})([
    "padding:24px;height:490px;width:100%;background-image:url(",
    ");position:absolute;background-repeat:no-repeat;background-size:cover;background-position:center;"
], function(param) {
    var $isSSR = param.$isSSR;
    return optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/a2433fe4b864a396996e79b48f5b39939f1353d65ea2cb4439823e87dc29e3eb.png"
    }, $isSSR, {
        height: 490
    });
});
var SummarySection = styled(Column).withConfig({
    componentId: "sc-6b0a6fde-2"
})([
    "position:absolute;bottom:0;border-top-left-radius:12px;border-top-right-radius:12px;background-color:",
    ";z-index:1;"
], Core.surface.inverse);
